import * as UI from "../../../../modules/ui-kit";

export default function Colors(props) {
    const { onChange, value } = props;

    if (!value) {
        return (
            <UI.Field>
                <UI.Button
                    onClick={ () => onChange({}) }
                >
                    Configure
                </UI.Button>
            </UI.Field>
        );
    }

    const writer = {
        accent: (accent) => onChange({ ...value, accent }),
        primary: (primary) => onChange({ ...value, primary }),
        secondary: (secondary) => onChange({ ...value, secondary }),
        tertiary: (tertiary) => onChange({ ...value, tertiary }),
    };

    return (
        <UI.Field>
            <UI.Field>
                <UI.FieldLabel>Accent</UI.FieldLabel>
                <Color
                    onChange={ writer.accent }
                    value={ value?.accent }
                />
            </UI.Field>
            <UI.Field>
                <UI.FieldLabel>Primary</UI.FieldLabel>
                <Color
                    onChange={ writer.primary }
                    value={ value?.primary }
                />
            </UI.Field>
            <UI.Field>
                <UI.FieldLabel>Secondary</UI.FieldLabel>
                <Color
                    onChange={ writer.secondary }
                    value={ value?.secondary }
                />
            </UI.Field>
            <UI.Field>
                <UI.FieldLabel>Tertiary</UI.FieldLabel>
                <Color
                    onChange={ writer.tertiary }
                    value={ value?.tertiary }
                />
            </UI.Field>
        </UI.Field>
    );
}

function Color(props) {
    const { onChange, value } = props;

    if (!value) {
        return (
            <UI.Field>
                <UI.Button
                    onClick={ () => onChange({}) }
                >
                    Configure
                </UI.Button>
            </UI.Field>
        );
    }

    const writer = {
        contrastText: (contrastText: string) => onChange({ ...(value ?? {}), contrastText }),
        dark: (dark: string) => onChange({ ...(value ?? {}), dark }),
        light: (light: string) => onChange({ ...(value ?? {}), light }),
        main: (main: string) => onChange({ ...(value ?? {}), main }),
    };

    return (
        <UI.Field>
            <UI.Field>
                <UI.FieldLabel>Contrast text</UI.FieldLabel>
                <UI.TextInput
                    onChange={ writer.contrastText }
                    placeholder="Contrast text"
                    value={ value?.contrastText ?? "" }
                />
            </UI.Field>
            <UI.Field>
                <UI.FieldLabel>Dark</UI.FieldLabel>
                <UI.TextInput
                    onChange={ writer.dark }
                    placeholder="Dark"
                    value={ value?.dark ?? "" }
                />
            </UI.Field>
            <UI.Field>
                <UI.FieldLabel>Light</UI.FieldLabel>
                <UI.TextInput
                    onChange={ writer.light }
                    placeholder="Light"
                    value={ value?.light ?? "" }
                />
            </UI.Field>
            <UI.Field>
                <UI.FieldLabel>Main</UI.FieldLabel>
                <UI.TextInput
                    onChange={ writer.main }
                    placeholder="Main"
                    required
                    value={ value?.main ?? "" }
                />
            </UI.Field>
            <UI.Button
                onClick={ () => onChange(undefined) }
            >
                Remove color configuration
            </UI.Button>
        </UI.Field>
    );
}
